import { useState } from 'react'
import { Sheet } from './Sheet'

/**
 * Số khách đang ngồi ở bàn.
 *
 * Bấm một con số là xong. Người bán đếm đầu khách trong lúc đi tới bàn, rồi bấm một cái —
 * không ai đứng gõ bàn phím trước mặt sáu người đang chờ gọi món.
 *
 * Khác với "số chỗ" của cái bàn: số chỗ là bàn kê được mấy ghế, chủ quán khai một lần lúc
 * dựng sơ đồ. Số này là hôm nay bàn ấy đang có mấy người, mỗi lượt khách một khác — quán
 * cần nó để biết trung bình một khách trả bao nhiêu, và để chia bill khi khách hỏi.
 */

/** Mấy nhóm khách hay gặp nhất. Hơn tám người thì bấm dấu cộng, hiếm khi phải bấm nhiều. */
const QUICK = [1, 2, 3, 4, 5, 6, 8]

interface Props {
  guests: number
  tableName: string
  onSave: (guests: number) => void | Promise<void>
  onClose: () => void
}

export function GuestSheet({ guests, tableName, onSave, onClose }: Props) {
  const [n, setN] = useState(guests)

  async function done(value: number) {
    await onSave(Math.max(0, value))
    onClose()
  }

  return (
    <Sheet title={`Số khách · ${tableName}`} onClose={onClose}>
      <div className="chip-row chip-cash">
        {QUICK.map((q) => (
          <button
            key={q}
            type="button"
            className="chip num"
            aria-pressed={n === q}
            onClick={() => void done(q)}
          >
            {q}
          </button>
        ))}
      </div>

      <div className="field">
        <span>Hoặc chỉnh từng người</span>
        <div className="stepper stepper-lg">
          <button type="button" onClick={() => setN((v) => Math.max(0, v - 1))} aria-label="Bớt một khách">
            −
          </button>
          <span className="num">{n}</span>
          <button type="button" onClick={() => setN((v) => Math.min(99, v + 1))} aria-label="Thêm một khách">
            +
          </button>
        </div>
      </div>

      <div className="sheet-actions">
        <button type="button" className="btn btn-ghost" onClick={() => void done(0)}>
          Chưa đếm
        </button>
        <button type="button" className="btn btn-brand grow" onClick={() => void done(n)}>
          Lưu
        </button>
      </div>
    </Sheet>
  )
}
